import {isSelectedTab} from './../../../utils/commonFunctions';
import UseApiService from './../../../services/Api.service';
import * as constants from './../../../constants/constants';
import { useEffect, useState } from 'react';

import { Table } from 'antd';

export default function CustomerOfertasComponent({selectedTab}){
  const [dataList,setDataList] = useState([]);

  const columns = [
    /*
    {
      title: '',
      dataIndex: 'imagepath',
      render: (text) => (<><img src={text} style={{width:'80px'}} /></>)
    },
    */
    {
      title: 'Titulo',
      dataIndex: 'title',
      //sorter: (a, b) => a.name.localeCompare(b.section), 
    },
    {
      title: 'Enlace',
      dataIndex: 'url',
      render: (text) => (<a className='link-overflow' href={text} target='_bank' > {text}</a>)
    }
  ];


  useEffect(()=>{
    getData();
  },[])

  const getData = () =>{
    let url = constants.U_API+"?type=promociones";
    UseApiService(url,{method:'GET'})
    .then(({data,error})=>{
      if(error){
        console.log(error);
      }
      else{       
        setDataList(data);
      }
    })
    .catch((e)=>{
      console.log(e);
    })
    .finally((e)=>{
      console.log(e);
    })
  }

  return(
    <>
      <div className={isSelectedTab(selectedTab,'ofertas')}>        
        <Table
          columns={columns} 
          dataSource={dataList} 
          pagination={{ pageSize: 6 }} 
          rowKey="id"
          size="small"
        />
      </div>      
    </>
  )
}